import React from 'react'
import { View } from 'react-native'
import tw from 'tailwind-rn'
import { useSelector } from 'react-redux'
import { BlockImageGalleryType } from '../../config/types'
import ImageSlider from '../ImageSlider'

type Props = {
  data: BlockImageGalleryType
}

const BlockImageGallery = (props: Props) => {
  const { data } = props
  const { images } = data
  const { accessToken } = useSelector((state) => state.user)

  const sliderData = images.map(
    ({ directus_files_id: { id: imageId, title, description } }) => {
      const imageUrl = `${process.env.DIRECTUS_API_URL}/assets/${imageId}?access_token=${accessToken}`

      return {
        title,
        description,
        imageUrl,
      }
    }
  )

  return (
    <View style={tw('pb-6')}>
      <ImageSlider sliderData={sliderData} />

      {/* {images.map((i) => {
        const { title } = i
        const imageUrl = `${process.env.DIRECTUS_API_URL}/assets/${i.image.id}?access_token=${accessToken}`

        return (
          <View key={i.id}>
            <HGText>{title}</HGText>
            <Image
              style={{ width: 300, height: 200 }}
              source={{
                uri: imageUrl,
              }}
            />
          </View>
        )
      })} */}
    </View>
  )
}

export default BlockImageGallery
